module.exports = __webpack_public_path__ + "static/media/espn_nba_story___id_15047018_how-nike-lost-stephen-curry-armour_plot.21bfcae0.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/storySparklines/espn_nba_story___id_15047018_how-nike-lost-stephen-curry-armour_plot.png
// module id = 388
// module chunks = 0